<div class="loading-spinner">
</div>
<img alt src="/assets/img/logo-nav.svg">
